// src/contexts/CompanySettingsContext.js
import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';

const CompanySettingsContext = createContext();

export const useCompanySettings = () => useContext(CompanySettingsContext);

export const CompanySettingsProvider = ({ children }) => {
    const [companyLogo, setCompanyLogo] = useState(null);
    const [loaded, setLoaded] = useState(false);

    // Company settings API not available in trading app — skip fetch
    useEffect(() => {
        setLoaded(true);
    }, []);

    const updateCompanyLogo = useCallback((logoUrl) => {
        setCompanyLogo(logoUrl || null);
    }, []);

    return (
        <CompanySettingsContext.Provider value={{ companyLogo, updateCompanyLogo, loaded }}>
            {children}
        </CompanySettingsContext.Provider>
    );
};
